module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-1600@2x-43267d98897d85671f288a9c90947d76.jpg";